// Config for the ₹99 "Learn AI step by step" webinar at /webinar-aug — edit
// these values per webinar, no other code changes needed. Used by
// WebinarAugPage.tsx and WebinarAugThanksPage.tsx. (The July ₹9 webinar at
// /webinar has its own config in webinarConfig.ts.)

export const WEBINAR = {
  // Identifies the webinar in webinar_registrations.webinar_slug
  slug: 'learn-ai-aug2026',

  title: 'Your path into AI. No fake promises.',
  subtitle:
    'A live 2-hour session for people who program — but aren\'t working in AI yet. ' +
    'We walk one clear, step-by-step path from the code you already write to a working AI application, ' +
    'the same path-first approach behind cubemate.ai. Every step builds on the last — ' +
    'no "become an AI engineer in 30 days" pitch.',

  dateDisplay: 'Saturday, Aug 22 · 7:00–9:00 PM IST',

  entryPrice: '₹99',

  // TODO(Francis): paste the ₹99 Razorpay Payment Link URL (Dashboard →
  // Payment Links → create a fixed ₹99 link; set its callback/redirect URL to
  // https://cubemate.ai/webinar-aug/thanks). Empty string = skip payment and
  // go straight to the thanks page (useful for testing — DO NOT launch ads
  // while this is empty, registrations would be free).
  razorpayLink: 'https://rzp.io/rzp/A1eAji3h',

  // TODO(Francis): paste the fresh WhatsApp group invite link for this cohort.
  // Empty string = thanks page shows "watch your email & WhatsApp" fallback.
  whatsappLink: 'https://chat.whatsapp.com/J54XhpSYGDmK17D0rH80JG',

  // Google Ads conversion label — same "cubemate-webinar" registration action
  // as July (account-level, not webinar-specific). Empty string = Google
  // conversion not fired (Meta pixel events still fire regardless).
  googleAdsConversion: 'AW-18013772297/rjm_COuc8M4cEIm00Y1D',
};
